module.exports = __webpack_public_path__ + "static/media/phone4.ba12ec28.png";